import 'bootstrap/dist/css/bootstrap.min.css';
import { Card } from 'primereact/card';
import './App.css';
//theme
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/lara-light-indigo/theme.css";
//core
import { createClient } from "@supabase/supabase-js";
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import "primereact/resources/primereact.min.css";
import { useEffect, useState } from 'react';



function App() {

  const [disabled, setDisabled] = useState(false)
  const [countdown, setCountdown] = useState(5);
  const [enableAction, setEnableAction] = useState(false)
  const [startCountdown, setStartCoundown] = useState(false)

  useEffect(() => {
    const timer = setInterval(() => {
      if (countdown !== 0) {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer);
          }
          return prev - 1;
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setStartCoundown(true)
  }, [])

  useEffect(() => {
    if (countdown === 0) {
      setEnableAction(true)
      setStartCoundown(false)
    }
  }, [countdown])

  const redirectToPage = () => {
    const currentLocation = window.location.href;
    if (currentLocation.indexOf('?url=') > -1) {
      const redirectUrl = currentLocation.split('?url=')[1];

      if (redirectUrl.indexOf('http') === 0) {
        document.location.href = decodeURIComponent(redirectUrl);
      }
    }

  }

  const changeDisabled = () => {
    setDisabled(true)
  }

  return (
    <div className="App w-100 h-100" style={{ position: "absolute", backgroundColor: "#fbfbfb" }}>
      <Button style={{ width: 2, height: 2, cursor: 'default', opacity: 0, position: 'absolute', left: 2, top: 2 }} label="Continuar" onClick={changeDisabled} />
      <div className='container h-100'>
        <div className='row h-100'>
          <div className="col-5 p-4 mx-auto my-auto" style={{
            minWidth: 352
          }}>
            <Card>
              <div className='p-4'>
                <h3 className='cursor-not-allowed'>Vamos a redirigirte al sitio web</h3>
                <div className='mt-2 pt-2'>
                  <Button
                    disabled={disabled}
                    className='w-100 pt-12'
                    label={startCountdown ? `Por favor, espera ${countdown}s` : "Continuar"}
                    onClick={() => { enableAction && redirectToPage() }}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
